/*
 * @Author: alenLee
 * @Date: 2020-08-16 03:29:48
 * @LastEditTime: 2020-08-25 16:34:20
 * @LastEditors: alenLee
 * @Description: 
 * @FilePath: /pdfmake/src/pdfKitEngine.js
 * @一诺心康
 */
'use strict';

function _interopDefault (ex) {
	return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex;
}

var PdfKit = _interopDefault(require('pdfkit'));

function getEngineInstance () {
	return PdfKit;
}

function createPdfDocument (options) {
	options = options || {};
	return new PdfKit(options);
}

module.exports = {
	getEngineInstance: getEngineInstance,
	createPdfDocument: createPdfDocument
};
